var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { debugLog } from "./debugLog";
import { layerConfig } from "./fetchLayerConfig";
import { getParameter } from "./getParameter";
import { subscribe } from "./messageBus";
let gameOrigin = window.location.origin;
const fetchGameOrigin = (gameId) => __awaiter(void 0, void 0, void 0, function* () {
    if (layerConfig.gameOrigin !== undefined) {
        return layerConfig.gameOrigin;
    }
    if (gameId.startsWith("rlx.")) {
        const targetOriginApiUrl = layerConfig.targetOriginApiUrl;
        if (targetOriginApiUrl === undefined) {
            throw new Error("targetOriginApiUrl not found");
        }
        const response = yield fetch(targetOriginApiUrl + "?gameref=" + gameId);
        const result = yield response.json();
        if (result.targetorigin) {
            return result.targetorigin;
        }
        else {
            throw new Error("Failed to get game origin");
        }
    }
    else {
        return window.location.origin;
    }
});
const isOriginCheckEnabled = () => {
    if (process.env.MODE === "development" && getParameter("verifyorigin") === "true") {
        return true;
    }
    if (process.env.VERIFY_ORIGIN === "true") {
        return true;
    }
    return false;
};
export const prepareGameOrigin = () => {
    if (!isOriginCheckEnabled()) {
        gameOrigin = "*";
        debugLog("Origin verification and targeting is disabled (dev build, can be enabled with &verifyorigin=true)");
        return;
    }
    if (layerConfig.targetOrigin === undefined && layerConfig.allowedOrigins === undefined) {
        gameOrigin = "*";
        debugLog("layerConfig targetOrigin not set and no origins are whitelisted: any origin is accepted");
        return;
    }
    subscribe("nx-game-frame-load-started", (payload) => {
        fetchGameOrigin(payload.gameId).then((result) => {
            gameOrigin = result;
            debugLog(`Game origin set to ${gameOrigin}`);
        }, (reason) => {
            debugLog("Failed to set game origin:", reason);
        });
    });
};
export const getGameOrigin = () => {
    return gameOrigin;
};
export const isAllowedGameOrigin = (origin) => {
    return origin === gameOrigin || gameOrigin === "*";
};
export const isAllowedOrigin = (origin) => {
    if (!isOriginCheckEnabled()) {
        return true;
    }
    if (isAllowedGameOrigin(origin)) {
        return true;
    }
    if (layerConfig.targetOrigin === undefined) {
        if (layerConfig.allowedOrigins === undefined) {
            return true;
        }
        const isWhitelisted = layerConfig.allowedOrigins.includes(origin);
        if (!isWhitelisted) {
            debugLog("Not a whitelisted origin: " + origin);
        }
        return isWhitelisted;
    }
    const isOperatorOrigin = origin === layerConfig.targetOrigin;
    if (!isOperatorOrigin) {
        debugLog(`Invalid origin ${origin} - Expected ${layerConfig.targetOrigin} or ${getGameOrigin()}`);
    }
    return isOperatorOrigin;
};
